import { client } from "./_base";

export const phlabel = client("phlabel", item => ({
  ...item,
}));
